import { IResponse } from "models";

export enum ActionType {
  DOWNLOAD_BUSINESS_USER_CSV = "action/DOWNLOAD_BUSINESS_USER_CSV",
  DOWNLOAD_BUSINESS_USER_CSV_SUCCESS = "action/DOWNLOAD_BUSINESS_USER_CSV_SUCCESS",
  DOWNLOAD_BUSINESS_USER_CSV_ERROR = "action/DOWNLOAD_BUSINESS_USER_CSV_ERROR",
  DOWNLOAD_BUSINESS_USER_CSV_RESET_DATA = "action/DOWNLOAD_BUSINESS_USER_CSV_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface DownloadBusinessUserCSVPayload {}

export interface DownloadBusinessUserCSVResponse extends IResponse {
  result: DownloadBusinessUserCSVData;
}

export interface DownloadBusinessUserCSVData {
  headers: any[];
  data: any[];
}
